import { Injectable } from '@angular/core';
import { LoadingState, LoadingStateHandlerService, mapLoadingReportState } from '@nk/utils-lib';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable()
export class LoadingStateService implements LoadingStateHandlerService {
  private _loadingState = new BehaviorSubject<LoadingState>({});
  public isReportLoading$ = this._loadingState.pipe(mapLoadingReportState({}), debounceTime(1000));

  public setLoadingState(loadingStateId: string, isLoading: boolean): void {
    this._loadingState.next({ [loadingStateId]: isLoading });
  }
}
